import React from 'react';
import PropTypes from 'prop-types';

class WebSocketManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            socketMessage: null,
        };
        this.websocket = null;
    }

    componentDidMount() {
        this.connect();
    }

    componentWillUnmount() {
        this.disconnect();
    }

    connect = () => {
        const { url } = this.props;
        this.websocket = new WebSocket(url);

        this.websocket.onopen = () => {
            console.log('WebSocket connected');
        };

        this.websocket.onmessage = (event) => {
            console.log('WebSocket message received:', event.data);
            this.props.onSocketMessage(event.data);
        };

        this.websocket.onclose = () => {
            console.log('WebSocket disconnected');
            // Try to reconnect in 5 seconds
            setTimeout(() => {
                this.connect();
             }, 5000);
        };

        this.websocket.onerror = (error) => {
            console.error('WebSocket error: ', error);
        };
    };

    disconnect = () => {
        if (this.websocket) {
            this.websocket.close();
        }
    };

    sendMessage = (message) => {
        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
            this.websocket.send(message);
        }
    };

  render() {
    // This component doesn't render anything itself
    return null;
  }
};

export default WebSocketManager;